// import moment from 'moment'
// const dateFormat = 'YYYY-MM-DD'
// const timeFormat = 'HH:mm:ss'

export function makeQuestionFormData (values, addToQuestionBank) {
  return {
    // class_id: this.onlineExamData.class_id,
    // section_id: this.onlineExamData.section_id,
    // subject_id: values.subject_id,
    online_exam_id: this.onlineExamData.id,
    question: this.question,
    question_no: this.question_no,
    description: values.description,
    instruction: values.instruction,
    mark: values.mark,
    // is_entry: values.is_entry,
    add_to_question_bank: addToQuestionBank ? 1 : 0,
    options: this.options.map(function(option) {
      delete option.id
      return option
    }),
  }
}

export function makeQuestionEditData (data) {
  return {
    // class_id: data.class_id,
    // section_id: data.section_id ? data.section_id : 0,
    // subject_id: data.subject_id,
    name: data.name,
    description: data.description,
    instruction: data.instruction,
    question_no: data.question_no,
    mark: data.mark,
    // is_entry: data.is_entry,
  }
}

export function makeOptionData (uid, data) {
  const options = data.options.map(function(option) {
    return {
      id: uid + Math.floor(Math.random() * 10000),
      value: option.value,
      is_entry: option.is_entry,
      mark: option.mark,
      correct: option.correct === 1,
    }
  })

  return options
}
